import { HHButton, HHStack } from '@hinge-health/react-component-library';
import { PropsWithChildren } from 'react';
import { PackageType } from '../../../types';
import { ActiveStatus } from '../../../utils/contract-utils';
import { DiscountType, IDiscount } from '../../../utils/discount-utils';
import { ScopeDisplay } from '../../scope-display/scope-display';

export interface DiscountDetailBaseProps {
  handleEditDiscountClick?: (discountDefinitionId: number) => void;
}

interface DiscountDetailBasePrivateProps extends DiscountDetailBaseProps {
  discountData: IDiscount;
  availablePackages: PackageType[];
}

const showEditButton = (
  status: ActiveStatus,
  discountType: DiscountType,
): boolean =>
  status !== ActiveStatus.Past &&
  discountType !== DiscountType.volumeBasedDiscounts;

export const DISCOUNT_DETAIL_TEST_ID = 'discount-row-test-id';

const DiscountDetailBase = ({
  children,
  handleEditDiscountClick,
  discountData,
}: PropsWithChildren<DiscountDetailBasePrivateProps>): JSX.Element => (
  <HHStack
    direction="column"
    spacing={4}
    padding={4}
    sx={{
      textTransform: 'capitalize',
    }}
    data-testid={DISCOUNT_DETAIL_TEST_ID}
  >
    <ScopeDisplay scopes={discountData.scopes} />
    {children}
    {handleEditDiscountClick &&
    showEditButton(
      discountData.status,
      discountData.discountType as DiscountType,
    ) ? (
      <HHStack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="end"
      >
        <HHButton
          hhVariant="variant-bypass"
          variant="outlined"
          size="medium"
          color="primary"
          onClick={(): void => {
            handleEditDiscountClick(discountData.discountDefinitionId);
          }}
        >
          Edit
        </HHButton>
      </HHStack>
    ) : null}
  </HHStack>
);

export default DiscountDetailBase;
